/**
 * Shared UI scale factor (device-pixel ratio, capped).
 *
 * The Phaser canvas renders at (CSS size × scale) for crisp text on High-DPI
 * displays, so scene coordinates are in device pixels. Author scene layout in
 * logical (CSS) pixels via px()/fontPx() and they are converted using the
 * live scale set at boot. This is mutable (not a frozen import-time constant)
 * because devicePixelRatio can be reported late by some hosts.
 */
let uiScale = clampDpr(
  typeof window !== 'undefined' ? window.devicePixelRatio : 1
);

function clampDpr(value: number): number {
  return Math.min(Math.max(value || 1, 1), 2);
}

/** Update the active scale (called from main.ts once the display DPR is known). */
export function setUiScale(dpr: number): void {
  uiScale = clampDpr(dpr);
}

export function getUiScale(): number {
  return uiScale;
}

/** Scale a logical pixel length to device pixels. */
export function px(logical: number): number {
  return logical * uiScale;
}

/** Build a device-pixel font-size string from a logical size. */
export function fontPx(logical: number): string {
  return `${logical * uiScale}px`;
}
